export default __webpack_public_path__ + "static/media/avanishLink.a5f5950c.png";